import { useLayoutEffect, useRef, useState } from "react";
import styled from "styled-components";
import { SPACING } from "../../constants/design/spacing";
import { TEXT_COLORS } from "../../constants/design/colors";
import { RestrictedCountries } from "../Settings/RestrictedCountries";

const Page = styled.main`
  box-sizing: border-box;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: ${SPACING.three}px;
  overflow: auto;

  h1 {
    margin: 0 0 ${SPACING.two}px;
    font-size: 20px;
  }

  > p {
    margin: 0;
    color: ${TEXT_COLORS.two};
    line-height: 1.5;
  }
`;

export function Geolocations() {
  const page = useRef<HTMLElement>(null);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    const element = page.current;
    if (!element) return undefined;

    // The desktop navigation can wrap, so use its actual rendered height.
    const measure = () =>
      setHeight(
        Math.max(0, window.innerHeight - element.getBoundingClientRect().top)
      );
    const observer = new ResizeObserver(measure);
    if (element.parentElement) {
      Array.from(element.parentElement.children).forEach((sibling) => {
        if (sibling !== element) observer.observe(sibling);
      });
    }
    window.addEventListener("resize", measure);
    measure();
    return () => {
      observer.disconnect();
      window.removeEventListener("resize", measure);
    };
  }, []);

  return (
    <Page ref={page} style={{ height }}>
      <h1>Geolocations</h1>
      <p>
        View the current blocked countries and add or remove country restrictions.
      </p>
      <RestrictedCountries />
    </Page>
  );
}
